export default __webpack_public_path__ + "static/friendliesFlag-31e3f6d5c4e47b5ce1d3838b12319058.svg";